@if (isOpen) {
<div class="aprova-validation-error-modal__overlay" (click)="handleClose()">
  <div class="aprova-validation-error-modal" (click)="$event.stopPropagation()">
    <div class="aprova-validation-error-modal__content">
      <!-- Icon -->
      <div class="aprova-validation-error-modal__icon-container">
        <aprova-icon
          name="exclamation-circle-solid"
          size="lg"
          color="#DC2626"
        />
      </div>

      <!-- Title and Message -->
      <div class="aprova-validation-error-modal__text">
        <h2 class="aprova-validation-error-modal__title">{{ title }}</h2>
        <p class="aprova-validation-error-modal__message">{{ message }}</p>
      </div>
    </div>

    <!-- Action Button -->
    <div class="aprova-validation-error-modal__actions">
      <aprova-button
        label="Revisar e tentar novamente"
        (click)="handleRetry()"
      />
    </div>
  </div>
</div>
}
